import React from "react";
import styles from "./styles/QurealCanvas.module.css";
import classNames from "classnames";
import { useMeasure, useMedia } from "react-use";
import { theme } from "antd";

function QurealCanvasWrapper({
    children,
    title,
    subtitle = null,
    controlPanel = null,
    actions = [],
    actions_left = [],
    actions_extra = [],
    actions_basics = [],
    isLoading,
    header_height = 50,
    open_cp,
    setOpenCp = () => {},
    bottom_panel = null,
}) {
    const [ref, { width, height }] = useMeasure();
    const isMobile = useMedia("(max-width: 800px)");
    const { token } = theme.useToken();

    const extraActions = actions_extra.filter(Boolean);
    const basicActions = actions_basics.filter(Boolean);

    const dotPatternBg = `
    linear-gradient(90deg, ${token.colorBgLayout} calc(20px - 1.5px), transparent 1%) center,
    linear-gradient(${token.colorBgLayout} calc(20px - 1.5px), transparent 1%) center,
    ${token.colorBorder}
  `;

    return (
        <div
            className={styles.wrapper}
            style={{ backgroundColor: token.colorBgLayout }}
        >
            <div
                className={styles.header}
                style={{
                    minHeight: header_height,
                    backgroundColor: token.colorBgContainer,
                    borderBottom: `1px solid ${token.colorBorderSecondary}`,
                    // boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
                }}
            >
                <div className={styles.header_left}>
                    {actions_left}
                    {title && (
                        <>
                            <div
                                className={styles.header_divider}
                                style={{ background: token.colorBorder }}
                            />
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    lineHeight: 1.3,
                                }}
                            >
                                <div
                                    className={styles.title}
                                    style={{ color: token.colorText }}
                                >
                                    {title}
                                </div>
                                {subtitle && (
                                    <div
                                        style={{
                                            fontSize: 11,
                                            color: token.colorTextTertiary,
                                        }}
                                    >
                                        {subtitle}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>
                <div className={styles.header_right}>
                    {actions}
                    {!isMobile && extraActions.length > 0 && (
                        <>
                            {extraActions}
                            {basicActions.length > 0 && (
                                <div
                                    className={styles.header_divider}
                                    style={{ background: token.colorBorder }}
                                />
                            )}
                        </>
                    )}
                    {basicActions}
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: isMobile ? "column" : "row-reverse",
                    flex: 1,
                    minHeight: 0,
                }}
            >
                <div
                    ref={ref}
                    className={classNames([
                        styles.canvas,
                        styles.editor_back_pattern,
                    ])}
                    style={{
                        background: dotPatternBg,
                        backgroundSize: "20px 20px",
                        ...(isMobile ? { order: 1, flex: "none" } : {}),
                    }}
                >
                    {children}
                </div>
                <div
                    className={classNames({
                        [styles.control_panel]: true,
                        [styles.control_panel_collapse]: !open_cp,
                    })}
                    style={{
                        backgroundColor: token.colorBgContainer,
                        borderRight:
                            open_cp && !isMobile
                                ? `1px solid ${token.colorBorderSecondary}`
                                : "none",
                        borderTop:
                            isMobile && open_cp
                                ? `1px solid ${token.colorBorderSecondary}`
                                : "none",
                        ...(isMobile
                            ? {
                                  height: "auto",
                                  maxHeight: "50%",
                                  width: "100%",
                                  flexShrink: 0,
                                  overflow: "auto",
                                  order: 2,
                              }
                            : {}),
                    }}
                >
                    {open_cp && controlPanel}
                    {open_cp && bottom_panel && (
                        <div
                            className={styles.bottom_panel}
                            style={{
                                borderTop: `1px solid ${token.colorBorderSecondary}`,
                                backgroundColor: token.colorBgLayout,
                            }}
                        >
                            {bottom_panel}
                        </div>
                    )}
                </div>
            </div>

            {isMobile && (
                <div className={styles.header_right}>{extraActions}</div>
            )}

            {isLoading && (
                <div
                    className={styles.loading_wrapper}
                    style={{
                        backgroundColor: token.colorBgMask,
                        color: token.colorTextLightSolid,
                    }}
                >
                    <span>Generating...</span>
                </div>
            )}
        </div>
    );
}

export default QurealCanvasWrapper;
